module.exports = __webpack_public_path__ + "img/zong.57fb1273.png";